module.exports = __webpack_public_path__ + "media/images/icons/instagram-9dc7c3c5bd375a73a93ff5ca0fac4a85.svg";